import { BaseService } from "./BaseService";
import { Configuration } from "Configuration";
import { LanguageClient, Language } from "./Client/ServiceClient";

/**
 * Service for getting languages.
 * @hidden
 */
export class LanguageService extends BaseService {
    /**
     * Get all available languages.
     */
    public get(): Promise<Language[]> {
        let client = new LanguageClient(Configuration.baseUrl);

        return new Promise<Language[]>((resolve, reject) => {
            client.get(
                (result) => resolve(result),
                (exception, reason) => {
                    reject(reason);
                }
            );
        });
    }
}
